import { createExperimentsDescriptor } from '@johnlewispartnership/wtr-website-decisioner-client/express';

export const MONETATE_DEFAULT_VARIANT = 'default';

export const INSPIRATION_GENERIC_CONTENT_PRODUCT_CAROUSEL = createExperimentsDescriptor(
  'inspiration_generic_content_product_carousel',
  {
    default: MONETATE_DEFAULT_VARIANT,
    showProductCarousel: 'showProductCarousel',
  },
);
